import React, { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { DataTable, SubHeading } from "../../../Components";
import { API_USER_ROLES } from "../../../utils/api/ApiConstant";
import { getAxios } from "../../../Services/commonService";
import Icon from "../../../assets/icons/Icon";
import { useNavigate } from "react-router-dom";
import { CommonModal, RoleDetailModal } from "../../../Modal";

const Roles = () => {
  const navigate = useNavigate();
  const { pagePermission } = useSelector((state) => state.user);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");
  const [headerSort, setHeaderSort] = useState({ column: 0, dir: "asc" });
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  const { isLoading, data } = useQuery({
    queryKey: [
      "rolesData",
      currentPage,
      recordsPerPage,
      searchTerm,
      headerSort,
    ],
    queryFn: async () => await getAxios(API_USER_ROLES, { page: 1, limit: 10 }),
  });

  const columns = useMemo(
    () => [
      {
        accessorKey: "role name",
        header: "role_name",
      },
      {
        accessorKey: "description",
        header: "description",
      },
      {
        accessorKey: "modules",
        header: "Modules",
        cell: ({ row }) => {
          const modules = row.original.modules || [];
          return modules.map((module) => module.moduleName).join(", ");
        },
      },
      {
        accessorKey: "action",
        header: "Action",
        cell: ({ row }) => (
          <div className="action_icon_box">
            <Icon
              name="FaEdit"
              className="btn btn-outline-secondary icon_button"
              cursorPointer={true}
              onClick={() =>
                navigate("/rolemanager/roles/create", {
                  state: {
                    rowData: row?.original,
                  },
                })
              }
              disabled={pagePermission?.updateAccess ? false : true}
            />
            <Icon
              name="FaEye"
              className="btn btn-outline-warning icon_button"
              cursorPointer={true}
              onClick={() =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: true,
                  rowData: row?.original,
                  name: "",
                  modalTitle: "Role Details",
                  modalContent: RoleDetailModal,
                }))
              }
              disabled={pagePermission?.viewAccess ? false : true}
            />
          </div>
        ),
      },
    ],
    []
  );

  const fetchData = () => {
    if (!data) return { data: [], pages: 0 };

    return {
      data: data.docs,
      pages: data.pages,
    };
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRecordsperPage = (value) => {
    setRecordsPerPage(value);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const handleHeaderSort = ({ index, direction }) => {
    setHeaderSort({ column: index, dir: direction });
  };

  return (
    <>
      <SubHeading
        subTitle="roles list"
        isAddBtnPage={true}
        isAddBtn={false}
        redirectPath="create"
        createAccess={pagePermission?.createAccess}
      />
      <div className="card-body">
        <DataTable
          columns={columns}
          fetchData={fetchData}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onRecordsPerPageChange={handleRecordsperPage}
          recordsPerPage={recordsPerPage}
          onSearchChange={handleSearch}
          isLoading={isLoading}
          handleHeaderSort={handleHeaderSort}
        />
      </div>

      <CommonModal
        isShow={isShow.isOpen}
        handleShowHide={() =>
          setIsShow((prev) => ({
            ...prev,
            isOpen: false,
            rowData: {},
            name: "",
          }))
        }
        modalTitle={isShow.modalTitle}
      >
        {isShow.modalContent &&
          React.createElement(isShow.modalContent, {
            handleShowHide: () =>
              setIsShow((prev) => ({
                ...prev,
                isOpen: false,
                rowData: {},
                name: "",
                modalTitle: "",
                apiFlag: !prev.apiFlag,
              })),
            rowData: isShow.rowData,
          })}
      </CommonModal>
    </>
  );
};

export default Roles;
